package com.castly.shared.dto

import kotlinx.serialization.Serializable

@Serializable
data class OnixImportPreview(
    val totalProducts: Int,
    val audiobookProducts: Int,
    val skippedNonAudiobook: Int,
    val onixVersion: String,
    val products: List<OnixProductPreview>,
    val parseErrors: List<OnixParseError> = emptyList()
)

@Serializable
data class OnixProductPreview(
    val isbn: String,
    val title: String,
    val subtitle: String? = null,
    val authorName: String? = null,
    val narratorName: String? = null,
    val publisher: String? = null,
    val durationSeconds: Int? = null,
    val language: String? = null,
    val isAbridged: Boolean? = null,
    val description: String? = null,
    val coverImageUrl: String? = null,
    val seriesName: String? = null,
    val seriesPosition: String? = null,
    val subjects: List<String> = emptyList(),
    val audienceRating: String? = null,
    val publicationDate: String? = null,
    val copyrightYear: Int? = null,
    val validationStatus: String = "valid",
    val validationErrors: List<String> = emptyList(),
    val isDuplicate: Boolean = false,
    val existingAudiobookId: String? = null,
    val fieldDiff: Map<String, FieldDiff>? = null
)

@Serializable
data class FieldDiff(
    val currentValue: String? = null,
    val incomingValue: String? = null
)

@Serializable
data class OnixParseError(
    val productIndex: Int,
    val isbn: String? = null,
    val error: String
)

@Serializable
data class OnixImportConfirmRequest(
    val products: List<OnixProductAction>,
    val labelId: Int? = null
)

@Serializable
data class OnixProductAction(
    val isbn: String,
    val action: String,
    val fieldsToUpdate: List<String> = emptyList()
)
